import { ApiResult } from '@root/api/core/ApiResult'
import { useTranslation } from 'react-i18next'

export function useHandleAppointmentError(error?: ApiResult) {
  const { t } = useTranslation()

  const getErrorMessage = (error: ApiResult | undefined) => {
    console.log('error', error)
    if (!error) return undefined
    if (
      error.status === 403 ||
      (error?.message?.includes('Forbidden: ') &&
        error?.message?.includes('but it is not current'))
    )
      return t('errorModal.formIsNotLatest')

    if (error.status === 404) return t('errorModal.appointmentNotFound')
    if (error.status === 410) return t('errorModal.appointmentCancelled')
    if (error.status === 412) return t('errorModal.appointmentIsNEE')

    return t('errorModal.title')
  }

  const errorMessage = getErrorMessage(error)

  return {
    errorMessage,
  }
}
